import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import styles from './server/elements/Table.module.css';
import type { ColumnField } from './server/types';
import ValueCell from './server/ValueCell';
import { useDataColumnValue, useField } from './utils/TableStore';
import WithResize from './WithResize';
const ValueCellWithResize = WithResize(ValueCell);
function DataCell(t0) {
  const $ = _c(6);
  const {
    field,
    dataId,
    firstRow,
    colIndex
  } = t0;
  const value = useDataColumnValue(field, dataId);
  const res = useField(field);
  const render = res?.render;
  const t1 = firstRow ? styles.headerCell : undefined;
  let t2;
  if ($[0] !== colIndex || $[1] !== firstRow || $[2] !== render || $[3] !== t1 || $[4] !== value) {
    t2 = <ValueCellWithResize render={render} value={value} className={t1} colIndex={colIndex} firstRow={firstRow} />;
    $[0] = colIndex;
    $[1] = firstRow;
    $[2] = render;
    $[3] = t1;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export default memo(DataCell);